import { useState } from 'react';

const BR_2_IMG =
  'https://storage.readdy-site.link/project_files/794dc72f-0fe0-459a-adfa-e9a96db79dda/803c9476-2738-4a10-8579-c4519ae2931e_vela-bay-2br.png?v=9274022a0bf38c1d91ef9aae28be97f7';

const BR_3_IMG =
  'https://storage.readdy-site.link/project_files/794dc72f-0fe0-459a-adfa-e9a96db79dda/7c89cf49-b457-46bb-913c-75d258ff9eac_vela-bay-3br.png?v=d92d9c3698e68fbc07a104abe1f37155';

const BR_5_IMG =
  'https://storage.readdy-site.link/project_files/794dc72f-0fe0-459a-adfa-e9a96db79dda/2bc03e2b-de66-44f9-b0b0-b0222cb3254c_vela-bay-5br.png?v=01fae3a54bd7eae6caf05c020faf8180';

interface BedConfig {
  label: string;
  image: string | null;
  toBeUpdated: boolean;
}

const BEDROOM_LIST: BedConfig[] = [
  { label: '1 BEDROOM LAYOUT', image: null, toBeUpdated: true },
  { label: '2 BEDROOM LAYOUT', image: BR_2_IMG, toBeUpdated: false },
  { label: '3 BEDROOM LAYOUT', image: BR_3_IMG, toBeUpdated: false },
  { label: '4 BEDROOM LAYOUT', image: null, toBeUpdated: true },
  { label: '5 BEDROOM LAYOUT', image: BR_5_IMG, toBeUpdated: false },
];

export default function LayoutSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <section id="layout" className="py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        {/* Section Title */}
        <div className="mb-8 text-center">
          <h4
            className="text-2xl md:text-3xl font-bold tracking-widest uppercase text-[#172C37]"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            Vela Bay Layout
          </h4>
          <div className="mt-3 mx-auto w-16 h-[2px] bg-amber-400" />
        </div>

        {/* Accordion Items */}
        <div className="flex flex-col gap-3">
          {BEDROOM_LIST.map((bed, idx) => (
            <div key={bed.label} className="rounded-2xl overflow-hidden border border-[#172C37]/15">
              {/* Accordion Button */}
              <button
                type="button"
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between bg-[#172C37] text-white px-6 py-4 cursor-pointer hover:bg-[#1e3a4a] transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-layout-grid-line text-base text-amber-300" />
                  </div>
                  <span
                    className="text-sm md:text-base font-bold tracking-widest uppercase"
                    style={{ fontFamily: '"Cormorant Garamond", serif' }}
                  >
                    {bed.label}
                  </span>
                </div>
                <div className="w-7 h-7 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-xl transition-transform duration-300 ${
                      openIndex === idx ? 'rotate-180' : 'rotate-0'
                    }`}
                  />
                </div>
              </button>

              {/* Accordion Content */}
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === idx ? 'max-h-[4000px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="bg-[#f9f7f4] p-4 md:p-6">
                  {bed.toBeUpdated ? (
                    <div className="flex items-center justify-center py-12">
                      <p
                        className="text-lg md:text-xl font-semibold tracking-widest uppercase text-[#172C37]/50"
                        style={{ fontFamily: '"Cormorant Garamond", serif' }}
                      >
                        TO BE UPDATED
                      </p>
                    </div>
                  ) : (
                    <div className="rounded-xl overflow-hidden">
                      <img
                        src={bed.image!}
                        alt={`Vela Bay ${bed.label} Singapore Bayshore`}
                        title={`Vela Bay ${bed.label}`}
                        className="w-full h-auto object-top"
                        loading="lazy"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
